import React from "react";

export const IconFish = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="fishGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f43f5e" />
        <stop offset="50%" stopColor="#ef4444" />
        <stop offset="100%" stopColor="#b91c1c" />
      </linearGradient>
      <linearGradient id="finGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fda4af" />
        <stop offset="100%" stopColor="#f43f5e" />
      </linearGradient>
    </defs>
    <path d="M12 40 C6 48, 4 54, 10 54 C16 54, 20 44, 24 38 C18 42, 10 44, 12 40 Z" fill="url(#finGrad)" />
    <path d="M10 24 C4 18, 2 12, 8 12 C14 12, 18 22, 22 28 C16 24, 8 22, 10 24 Z" fill="url(#finGrad)" />
    <path d="M16 34 C20 20, 36 14, 54 22 C60 30, 52 46, 32 48 C20 49, 14 42, 16 34 Z" fill="url(#fishGrad)" />
    <path d="M22 38 C28 46, 42 46, 52 32 C46 42, 32 46, 22 38 Z" fill="#fff" opacity="0.8" />
    <path d="M30 18 C38 10, 46 14, 48 20 C42 16, 34 16, 30 18 Z" fill="url(#finGrad)" />
    <path d="M30 26 Q34 22 38 26 M36 30 Q40 26 44 30 M28 34 Q32 30 36 34" stroke="#fecdd3" strokeWidth="1.5" strokeLinecap="round" opacity="0.7" fill="none" />
    <circle cx="48" cy="24" r="3.5" fill="#ffffff" />
    <circle cx="48" cy="24" r="2" fill="#0f172a" />
    <circle cx="49" cy="23" r="0.8" fill="#ffffff" />
    <path d="M54 22 C56 24, 56 26, 54 28" stroke="#9f1239" strokeWidth="1.5" fill="none" />
    <path d="M52 28 C56 32, 58 34, 60 32" stroke="#fda4af" strokeWidth="1.5" fill="none" strokeLinecap="round" />
  </svg>
);

export const IconShrimp = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="shrimpGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fb923c" />
        <stop offset="50%" stopColor="#f97316" />
        <stop offset="100%" stopColor="#c2410c" />
      </linearGradient>
    </defs>
    <path d="M46 18 C52 10, 58 8, 62 6 M48 20 C56 16, 60 14, 63 12" stroke="#ea580c" strokeWidth="1.5" strokeLinecap="round" fill="none" />
    <path d="M48 22 C42 16, 26 14, 18 24 C10 34, 14 48, 24 54 C20 48, 22 36, 32 30 C40 25, 48 26, 48 22 Z" fill="url(#shrimpGrad)" />
    <path d="M40 20 C32 22, 28 28, 28 34 M34 24 C28 28, 24 34, 24 40 M28 30 C22 34, 20 42, 20 46" stroke="#ffedd5" strokeWidth="1.5" strokeLinecap="round" opacity="0.8" fill="none" />
    <path d="M24 54 C18 58, 12 60, 10 56 C14 54, 18 50, 20 46 C20 50, 22 53, 24 54 Z" fill="#ea580c" />
    <circle cx="44" cy="20" r="2.5" fill="#0f172a" />
    <circle cx="45" cy="19" r="0.8" fill="#ffffff" />
    <path d="M38 30 C34 36, 30 38, 28 40 M42 26 C38 32, 36 36, 34 38" stroke="#c2410c" strokeWidth="1.5" strokeLinecap="round" fill="none" />
  </svg>
);

export const IconGourd = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="gourdGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fef08a" />
        <stop offset="40%" stopColor="#eab308" />
        <stop offset="100%" stopColor="#854d0e" />
      </linearGradient>
    </defs>
    <circle cx="32" cy="22" r="10" fill="url(#gourdGrad)" />
    <circle cx="32" cy="42" r="16" fill="url(#gourdGrad)" />
    <ellipse cx="28" cy="18" rx="3" ry="5" fill="#ffffff" opacity="0.5" transform="rotate(-20 28 18)" />
    <ellipse cx="26" cy="38" rx="4" ry="8" fill="#ffffff" opacity="0.4" transform="rotate(-20 26 38)" />
    <path d="M32 12 C32 7, 36 5, 38 4 C37 6, 35 8, 34 12 Z" fill="#65a30d" />
    <rect x="22" y="29" width="20" height="4" rx="2" fill="#b91c1c" />
    <path d="M30 32 C28 39, 24 43, 22 45 M34 32 C36 39, 38 42, 40 44" stroke="#dc2626" strokeWidth="2.5" strokeLinecap="round" fill="none" />
  </svg>
);

export const IconDeer = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="deerGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fde047" />
        <stop offset="50%" stopColor="#d97706" />
        <stop offset="100%" stopColor="#92400e" />
      </linearGradient>
    </defs>
    <path d="M26 18 L22 8 M24 12 L18 10 M26 14 L20 16 M38 18 L42 8 M40 12 L46 10 M38 14 L44 16" stroke="#78350f" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    <path d="M22 28 C22 20, 42 20, 42 28 C42 34, 38 38, 38 46 C38 52, 46 54, 44 58 C38 60, 26 60, 20 54 C16 48, 18 36, 22 28 Z" fill="url(#deerGrad)" />
    <path d="M20 24 C14 22, 12 26, 18 28 Z" fill="#b45309" />
    <path d="M44 24 C50 22, 52 26, 46 28 Z" fill="#b45309" />
    <path d="M26 38 C30 36, 34 36, 36 38 C36 48, 32 54, 26 52 Z" fill="#fef3c7" />
    <circle cx="24" cy="44" r="1.5" fill="#ffffff" />
    <circle cx="28" cy="48" r="1.5" fill="#ffffff" />
    <circle cx="22" cy="50" r="1.5" fill="#ffffff" />
    <circle cx="36" cy="26" r="2" fill="#0f172a" />
    <circle cx="36.5" cy="25.5" r="0.6" fill="#ffffff" />
    <ellipse cx="41" cy="29" rx="1.5" ry="1" fill="#78350f" />
  </svg>
);

export const IconCrab = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="crabGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#f87171" />
        <stop offset="50%" stopColor="#ef4444" />
        <stop offset="100%" stopColor="#991b1b" />
      </linearGradient>
    </defs>
    <path d="M18 24 C10 16, 6 22, 12 30 C16 32, 20 28, 18 24 Z" fill="url(#crabGrad)" />
    <path d="M12 20 C6 14, 2 20, 8 26 C12 28, 14 24, 12 20 Z" fill="#dc2626" />
    <path d="M46 24 C54 16, 58 22, 52 30 C48 32, 44 28, 46 24 Z" fill="url(#crabGrad)" />
    <path d="M52 20 C58 14, 62 20, 56 26 C52 28, 50 24, 52 20 Z" fill="#dc2626" />
    <path d="M18 28 L24 34 M46 28 L40 34" stroke="#b91c1c" strokeWidth="3" strokeLinecap="round" fill="none" />
    <path d="M18 38 C12 42, 8 48, 10 52 M16 44 C10 48, 8 54, 12 56 M46 38 C52 42, 56 48, 54 52 M48 44 C54 48, 56 54, 52 56" stroke="#991b1b" strokeWidth="2.5" strokeLinecap="round" fill="none" />
    <ellipse cx="32" cy="40" rx="16" ry="12" fill="url(#crabGrad)" />
    <path d="M22 36 Q32 30 42 36" stroke="#fca5a5" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity="0.6" />
    <path d="M26 30 L26 24 M38 30 L38 24" stroke="#991b1b" strokeWidth="2" fill="none" />
    <circle cx="26" cy="23" r="2.5" fill="#0f172a" />
    <circle cx="26.5" cy="22.5" r="0.8" fill="#ffffff" />
    <circle cx="38" cy="23" r="2.5" fill="#0f172a" />
    <circle cx="38.5" cy="22.5" r="0.8" fill="#ffffff" />
  </svg>
);

export const IconRooster = () => (
  <svg viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="roosterGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fef08a" />
        <stop offset="50%" stopColor="#eab308" />
        <stop offset="100%" stopColor="#ca8a04" />
      </linearGradient>
      <linearGradient id="tailGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="50%" stopColor="#047857" />
        <stop offset="100%" stopColor="#064e3b" />
      </linearGradient>
    </defs>
    <path d="M26 36 C18 28, 10 20, 4 24 C10 32, 16 38, 22 42 Z" fill="url(#tailGrad)" />
    <path d="M24 38 C14 34, 6 30, 2 36 C8 42, 16 44, 22 46 Z" fill="#0284c7" />
    <path d="M26 42 C18 44, 10 46, 8 52 C14 52, 20 48, 24 46 Z" fill="#6366f1" />
    <path d="M24 34 C28 26, 36 24, 42 28 C48 32, 46 44, 38 50 C30 54, 24 46, 24 34 Z" fill="url(#roosterGrad)" />
    <path d="M28 38 C32 36, 38 38, 36 44 C34 48, 30 46, 28 38 Z" fill="#ea580c" />
    <path d="M38 30 C40 24, 44 20, 46 16 C48 20, 46 26, 42 32 Z" fill="#ef4444" />
    <path d="M44 14 C44 10, 48 8, 50 12 C52 8, 54 10, 52 14 Z" fill="#dc2626" />
    <path d="M50 20 C52 24, 50 26, 48 24 Z" fill="#dc2626" />
    <path d="M50 17 L56 19 L50 21 Z" fill="#f59e0b" />
    <circle cx="46" cy="16" r="2" fill="#0f172a" />
    <circle cx="46.5" cy="15.5" r="0.6" fill="#ffffff" />
    <path d="M32 52 L30 60 M30 60 L26 62 M30 60 L32 62 M38 50 L38 58 M38 58 L34 60 M38 58 L40 60" stroke="#d97706" strokeWidth="2" strokeLinecap="round" fill="none" />
  </svg>
);

export const mascotSvgs = {
  1: <IconFish />,
  2: <IconShrimp />,
  3: <IconGourd />,
  4: <IconDeer />,
  5: <IconCrab />,
  6: <IconRooster />
};

export const symbolNames = {
  1: "Cá",
  2: "Tôm",
  3: "Bầu",
  4: "Nai",
  5: "Cua",
  6: "Gà"
};

export const BauCuaMascotBadge = ({ id, active, onClick }) => {
  return (
    <div
      className={`baucua-mascot-badge ${active ? "active" : ""}`}
      onClick={onClick}
      title={`${id} - ${symbolNames[id]}`}
    >
      <span className="gold-num">{id}</span>
      <div className="mascot-img">
        {mascotSvgs[id]}
      </div>
    </div>
  );
};
